import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = sessionStorage.getItem('mk_user');
    return u ? JSON.parse(u) : null;
  });

  const login = async (username, password, langOverride) => {
    const res = await apiLogin(username, password);
    const { token, user } = res.data;
    if (langOverride) user.lang = langOverride;
    sessionStorage.setItem('mk_token', token);
    sessionStorage.setItem('mk_user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    sessionStorage.removeItem('mk_token');
    sessionStorage.removeItem('mk_user');
    setUser(null);
  };

  // Called after a forced password change succeeds: drop the flag + persist.
  const clearMustChange = () => {
    setUser(u => {
      if (!u) return u;
      const next = { ...u, mustChangePassword: false };
      sessionStorage.setItem('mk_user', JSON.stringify(next));
      return next;
    });
  };

  const isAdmin    = user?.role === 'admin';
  const isParent   = user?.role === 'parent';
  const canWrite   = ['admin','director','office'].includes(user?.role);
  const canPay     = ['admin','director','accountant'].includes(user?.role);

  return (
    <AuthContext.Provider value={{ user, login, logout, clearMustChange, isAdmin, isParent, canWrite, canPay }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
